import React, { useState } from 'react';
import './blog-post.css';
import './blog-slides.css';

const ChloeMemberSpotlight = () => {
  return (
    <div>
      <div className='blog__container'>
        <div className="row">
            <div className="column">
                <header></header>

                <section>
                    <h2>Member Spotlight: Chloe Bogen</h2>
                    <p className="site-post-meta">May 22, 2026 - By: Kandyce Diep</p>
                    <hr></hr>
                </section>
                <section>
                    <p>Hi WiC Members!

                    <br></br>
                    For our very first WiC Member Spotlight, meet Chloe Bogen, our Social Events Director!
                    <br></br>
                    <br></br>


                    What's one thing people might be surprised to learn about you?
                    <br></br>
                    ● Chloe grew up in Japan and has a twin sister! She mentioned that growing up, they were
                    always a pair together. While being apart in college has been a big adjustment for both
                    of them, it has also given Chloe an opportunity to grow as her own individual.
                    <br></br>
                    <br></br>
                    What first sparked your interest in computing or tech? Was there a specific moment,
                    person, or experience that pulled you in?
                    <br></br>
                    ● Her interest in computing and tech started in high school when she took a CAD class for
                    fun. It turned out that her CAD professor was the robotics advisor and as a little bonus,
                    the teacher also gave extra credit to those who joined the robotics team. That
                    experience inspired Chloe to pursue engineering when she first started college. Although
                    she initially planned to major in mechanical engineering, she eventually switched to
                    computer science. Chloe mentioned how she got pulled into CS because she loved how
                    convenient it was to build a tangible project (for example, if you wanted to build a
                    website, you could do it yourself with a lot of available resources online).
                    <br></br>
                    <br></br>
                    What's something you're currently excited to be working toward — like a project,
                    internship, role, or long-term goal?
                    <br></br>
                    ● Chloe is excited to work with the World Food Programme (WFP) in the Office of
                    Investigative Operations where she will build AI tools to automate tasks. Her favorite part
                    is getting to work with a diverse range of professionals (lawyers, business professionals,
                    etc.) and how the applications she builds are deployed and have high impact within the
                    organization.
                    <br></br>
                    <br></br>
                    What's your favorite class?
                    <br></br>
                    ● CSE 332. Chloe enjoys project based classes and she mentioned how it's so cool that
                    you get to learn about various data structures and algorithms in short bursts. This results
                    in having something new everyday and keeps things interesting for her.
                    <br></br>
                    <br></br>
                    Favorite place to study on or near campus?
                    <br></br>
                    ● CSE2 Undergraduate Lounge
                    <br></br>
                    <br></br>
                    Looking back, what's one piece of advice you'd give someone starting their first-year in
                    CS at UW or joining WiC?
                    <br></br>
                    ● Chloe's first piece of advice is to take advantage of all the different opportunities to talk
                    to people older than you. This can help grow your network and potentially get
                    connections to a lot of cool opportunities that you might not know about. Upperclassmen
                    and professors also serve as good mentors for school, professional careers, and life in
                    general.
                    <br></br>
                    ● Her second advice is to apply to as many opportunities (clubs, internships, research,
                    etc.) as you can, even if you don't think you're qualified for it.
                    <br></br>
                    ● Her third advice is to know that you have time to explore in college. Your future isn't
                    decided by your first experiences at UW, for example, you're not “messing up” your
                    career if you don't get into a club. She reflected on her own experiences as a transfer
                    student to show that things will work out in the end.                    
                    <br></br>
                    <br></br>
                    
                    </p>
                </section>
                
            </div>
        </div>      
      </div>
    </div>
  );
};

export default ChloeMemberSpotlight;
